import { Radio, Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import { useAtom } from 'jotai'
import { pretreatmentMethodAtom } from './atom'
import { PretreatmentMethod } from '~/graphqls/types'
import compStyles from './PreProcessComp.module.css'
import { useEffect } from 'react'

export const options = [
  {
    name: '假涂鸦',
    id: PretreatmentMethod.FAKE_SCRIBBLE,
  },
  {
    name: '线稿涂鸦',
    id: PretreatmentMethod.SCRIBBLE,
  },
  {
    name: '无处理',
    id: PretreatmentMethod.INVERT_SCRIBBLE,
  },
]

export const PreProcessComp = () => {
  const [pretreatmentMethod, setPretreatmentMethod] = useAtom(
    pretreatmentMethodAtom
  )

  useEffect(() => {
    if (!pretreatmentMethod) {
      setPretreatmentMethod(options[0].id)
    }
  }, [])

  return (
    <MyForm.Item
      label={
        <span>
          预处理方式{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="假涂鸦可以生成涂鸦和上色图，线稿涂鸦可以生成线稿图和上色图，无处理建议上传的是线稿图"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-3')}
    >
      <Radio.Group
        className="!flex justify-start flex-wrap !-ml-2"
        value={pretreatmentMethod}
        onChange={e => {
          setPretreatmentMethod(e.target.value)
        }}
      >
        {options.map(item => {
          return (
            <Radio
              key={item.id}
              value={item.id}
              className={compStyles.customRadio}
            >
              <div
                className={classNames(
                  'flex relative items-center justify-between cursor-pointer py-4 px-3 h-[36px] border-2 border-solid border-neutral-200 rounded-full flex-1 bg-neutral-200 min-w-[174px]',
                  compStyles.radioBtn,
                  compStyles.modelBg
                )}
              >
                <div
                  className={classNames('flex-1 transition-all text-center')}
                >
                  <div className="text-neutral-800 font-semibold">
                    {item?.name}
                  </div>
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
